<template>
  <div style="margin-top: 30px; padding:11px;">

    <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal">
     Firma Kategori Ekle
    </button>

    <div class="table-responsive">
      <table class="table align-middle">
        <thead>
         <tr>
           <td>Kategori Adı</td>
           <td>Üst Kategori</td>
           <td>İşlemler</td>
         </tr>
        </thead>

        <tbody>
        <tr v-for="val in data" v-bind:key="val.id">
          <td>{{val.name}}</td>
          <td>{{val.upCategory}}</td>
          <td>
            <button type="button" class="btn btn-danger">Sil</button> &nbsp;
            <button type="button" class="btn btn-secondary">Düzenle</button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Kategori Ekle/Düzenle</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label for="exampleFormControlInput1" class="form-label">Kategori Adı</label>
              <input type="text" class="form-control" v-model="items.name" id="exampleFormControlInput1" placeholder="Kategori Adı">
            </div>

            <div class="form-check">
              <input class="form-check-input"
                     type="checkbox"
                     id="flexCheckDefault"
                     v-model="items.upCategory">
              <label class="form-check-label" for="flexCheckDefault">
                Alt Kategori
              </label>
            </div>

            <div class="mb-3" v-if="items.upCategory">
              <select class="form-select" v-model="items.parentId" v-if="items.upCategory"  aria-label="Üst Kategori">
                <option value="0"></option>
                <option v-for="val in upCategoryData" v-bind:key="val.id" :value="val.id">{{ val.name }}</option>
              </select>
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Vazgeç</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="saveItems">Kaydet</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ts-nocheck
import apiClient from "@/axios";
export default {
  name: "Users",
  data() {
    return {
      isMainCompany: false,
      data:[],
      items:{},
      upCategoryData:[]

    };
  },
  created() {

    this.getData();
  },
  methods:{
    getData(){
      apiClient.get('/definition-company-category?status=false').then(res => {
        this.data = res.data;
        this.upCategoryData = res.data.filter((element) => element.upCategory == false)
      })
    },
    saveItems(){
      apiClient.post('/definition-company-category', this.items).then(res => {
        if(res.data){
          this.getData();
        }
      })
    }

  }

}
</script>

<style scoped>

</style>